import { render } from "./cm-svg-icon.vue?vue&type=template&id=8f75bc4e&scoped=true&ts=true"
import script from "./cm-svg-icon.vue?vue&type=script&lang=ts"
export * from "./cm-svg-icon.vue?vue&type=script&lang=ts"

import "./cm-svg-icon.vue?vue&type=style&index=0&id=8f75bc4e&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f75bc4e"]])

export default __exports__